<template>
  <div class="loading-page" :style="{ height: height ? height : 'auto' }">
    <transition
      enter-active-class="transition duration-500 transform ease-out-quad"
      leave-active-class="transition duration-500 transform ease-in-quad"
      enter-class="scale-75 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-75 opacity-0"
      appear>
      <div class="loading-container">
        <div class="loading-spinner" :style="{ borderLeftColor: color }" />
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'Loading',

    props: {
      message: {
        type: String
      },

      height: {
        type: String
      },

      color: {
        type: String
      }
    }
  }
</script>

<style lang="postcss" scoped>
  @keyframes loaderSpin {
    from { transform:rotate(0deg); }
    to { transform:rotate(360deg); }
  }

  .loading-page {
    @apply h-full w-full flex items-center justify-center;
  }

  .loading-container {
    @apply text-center flex;
  }

  .loading-spinner {
    @apply inline-block h-6 w-6 mx-auto p-0 rounded-full border-2 border-gray-300;
    border-left:2px solid var(--primary-color);
    animation:loaderSpin 0.75s infinite linear;
  }
</style>
